/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DumpsterFire} from "../DumpsterFire";
import {DumpsterFireWinTypes, IWinRatioConfig} from "../server/DumpsterFireData";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {IFadeTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {gsap} from "gsap";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";


export class DumpsterFireSound {
    public static MAIN_GAME_MUSIC: string = "mainMusic";
    public static FS_INTRO: string = "fsMusic";
    public static FS_INTRO_MUSIC: string = "fsIntroMusic";
    public static FS_OUTRO_MUSIC: string = "fsOutroMusic";


    static AS_WIN: string = "asWin";
    static AS_WIN_BIG: string = "asWinBig";
    private _currentMusic: string;
    private player: NolimitAudioPlayer;
    private _countUpSound: NolimitHowl | undefined;
    static CAP_WIN_START: string = "capwinStart"
    static CAP_WIN_MUSIC: string = "capwinMusic";
    static CAP_WIN_ENDS: string = "capwinEnds";


    public static COUNT_UP_END_TINY: string = "winTiny";
    public static COUNT_UP_END_SMALL: string = "winSmall";
    public static COUNT_UP_END_MEDIUM: string = "winMedium";
    public static COUNT_UP_END_LARGE: string = "winLarge";
    public static COUNT_UP_END_FS: string = "winFsEnds";
    public static COUNT_UP: string = "countup";

    public static BIG_WIN_START: string = "bigwinStart";
    public static BIG_WIN_LEVEL: string = "bigwinLevel";
    public static FS_INTRO_START: string = "fsIntroStart";
    public static FS_OUTRO_START: string = "fsOutroStart";

    public static BIG_WIN_1_ENDS: string = "bigwinLevel1Ends";
    public static BIG_WIN_2_ENDS: string = "bigwinLevel2Ends";
    public static BIG_WIN_3_ENDS: string = "bigwinLevel3Ends";
    public static BIG_WIN_4_ENDS: string = "bigwinLevel4Ends";
    public static BIG_WIN_5_ENDS: string = "bigwinLevel5Ends";

    public static TRANSITION_SCREEN: string = "fsToMainTransition";
    public static EXTRA_SPIN_NO: string = "extraSpinNo";
    public static REELS_OUT: string = "spinStartReelSweep";
    public static REELS_LANDING_ANTICIPATION: string = "reelsLandingAnticipation";
    public static EXPLODE_SOUND_ARRAY: string[] = ["betlineShot1", "betlineShot2", "betlineShot3"];
    public static NORMAL_REELS_IN_ARRAY: string[] = ["reelsLandingNormal1", "reelsLandingNormal2", "reelsLandingNormal3"];
    public static FAST_REELS_IN_ARRAY: string[] = ["reelsLandingFast1", "reelsLandingFast2", "reelsLandingFast3"]
    public static COLLAPSE_REEL_SOUND_ARRAY: string[] = ["reelsLandingAvalanche1", "reelsLandingAvalanche2", "reelsLandingAvalanche3"];
    public static CLICK_YES_ARRAY: string[] = ["extraSpinYes1", "extraSpinYes2", "extraSpinYes3"];
    public static FIIL_UP_REEL_SOUND_ARRAY: string[] = ["reelsLandingAvalancheFallIn1", "reelsLandingAvalancheFallIn2", "reelsLandingAvalancheFallIn3"];
    public static X_BOMB_ARRAY: string[] = ["xBombLanding1", "xBombLanding2", "xBombLanding3"];

    public static BETLINE_AIM: string = "betlineAim";
    public static BETLINE_AIM_LOAD: string = "betlineAimLoad";

    public static X_WAYS_REVEAL: string = "xWaysReveal";
    public static XI_WAYS_REVEAL: string = "infectiousxWaysReveal";
    public static XI_START: string = "infectiousxWaysExpandStart";
    public static XI_STOP: string = "infectiousxWaysExpandStop";
    public static X_BOMB_EXPLODE: string = "xBombExplode";
    public static X_WAYS_LANDING: string = "xWaysLanding";
    public static XI_LANDING: string = "infectiousxWaysLanding";
    public static WILD_LANDING: string = "wildLanding";

    public static SCATTER_TRIGGER: string = "scatterWin";
    public static FS_INTRO_CAR: string = "fsIntroCar";
    public static FS_CONTINUE: string = "fsIntroContinueButton";
    public static FS_INTRO_WHEEL: string = "fsIntroWheel";
    public static FS_INTRO_WHEEL_BLINK: string = "fsIntroWheelBlink";
    public static FS_INTRO_UPGRADES_SIGN: string = "fsIntroUpgradesSign";


    public static SCATTER_ANTICIPATION: string = "scatterAnticipation";
    public static SCATTER_ANTICIPATION_END: string = "scatterAnticipationEnds";
    public static S_LANDING_1_2: string = "scatterLanding1and2";
    public static S_LANDING_3_UP: string = "scatterLanding3andUp";
    public static FS_PLUS_SPIN: string = "fsPlusSpin";
    public static MULTI_FIRE: string = "multiplierFire";

    private _intervalMap: Map<string, gsap.core.Timeline> = new Map<string, gsap.core.Timeline>();

    public _currentMulti: number = 2;

    constructor() {
        if (NolimitConfig.isDevMode) {
            DumpsterFireSound.soundPlayer.showLogs(true);
        }
        this.player = <NolimitAudioPlayer>SlotGame.sound
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    private static createConfig(name: string, volume?: number, repeat?: number) {
        return {
            name: name,
            volume: volume,
            repeat: repeat
        }
    }

    public avoidFrequentPlaySound(soundKey: string, soundName: string, interval?: number): boolean {
        let isAlreadyPlayed: boolean = true;
        if (!this._intervalMap.get(soundKey)) {
            const tl: gsap.core.Timeline = new gsap.core.Timeline();
            this._intervalMap.set(soundKey, tl)
            tl.to({}, {duration: interval || 0.0001});
            tl.add(() => {
                this._intervalMap.delete(soundKey);
                tl.pause().kill();
            })
            this.playSound(soundName);
            isAlreadyPlayed = false;
        }
        return isAlreadyPlayed;
    }

    public fadeMusic(fadeConfig: IFadeTrackConf): void {
        fadeConfig.name = fadeConfig.name || this._currentMusic;
        this.player.fadeTrack(fadeConfig);
    }

    public playReelsIn(array: string[]): string {
        const random: number = Math.floor(Math.random() * array.length);
        return array[random];
    }

    public playAnticipationSound(): void {
        this.playSound(DumpsterFireSound.SCATTER_ANTICIPATION);
        DumpsterFire.soundPlayer.fadeMusic({
            name: "",
            duration: 100,
            to: 0.6
        });
    }

    public stopAnticipationSound(): void {
        this.stopSoundEffect(DumpsterFireSound.SCATTER_ANTICIPATION);
        this.playSound(DumpsterFireSound.SCATTER_ANTICIPATION_END);
        DumpsterFire.soundPlayer.fadeMusic({
            name: "",
            duration: 100,
            to: 1
        });
    }

    public stopSoundEffect(name: string): void {
        DumpsterFireSound.soundPlayer.stopTrack(name);
    }

    public getXFeatureMultiSound(multi: number): TimelineLite {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (multi === 16 && this._currentMulti < multi) {
            this._currentMulti = 16;
        } else if (multi === 32) {
            this._currentMulti = 32;
        } else if (multi === 64) {
            this._currentMulti = 64;
        } else if (multi === 128 && this._currentMulti < multi) {
            this._currentMulti = 128;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.4, Number.MAX_VALUE);
        } else if (multi === 256 && this._currentMulti < multi) {
            this._currentMulti = 256;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.5, Number.MAX_VALUE);
        } else if (multi === 512 && this._currentMulti < multi) {
            this._currentMulti = 512;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.6, Number.MAX_VALUE);
        } else if (multi === 1024 && this._currentMulti < multi) {
            this._currentMulti = 1024;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.7, Number.MAX_VALUE);
        } else if (multi === 2048 && this._currentMulti < multi) {
            this._currentMulti = 2048;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.8, Number.MAX_VALUE);
        } else if (multi === 4096 && this._currentMulti < multi) {
            this._currentMulti = 4096;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.9, Number.MAX_VALUE);
        } else if (multi === 8192 && this._currentMulti < multi) {
            this._currentMulti = 8192;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 1.0, Number.MAX_VALUE);
        }
        return tl;
    }

    public getRestoreSound(multi: number): TimelineLite {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (multi === 16) {
            this._currentMulti = 16;
        } else if (multi === 32) {
            this._currentMulti = 32;
        } else if (multi === 64) {
            this._currentMulti = 64;
        } else if (multi === 128) {
            this._currentMulti = 128;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.4, Number.MAX_VALUE);
        } else if (multi === 256) {
            this._currentMulti = 256;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.5, Number.MAX_VALUE);
        } else if (multi === 512) {
            this._currentMulti = 512;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.6, Number.MAX_VALUE);
        } else if (multi === 1024) {
            this._currentMulti = 1024;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.7, Number.MAX_VALUE);
        } else if (multi === 2048) {
            this._currentMulti = 2048;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.8, Number.MAX_VALUE);
        } else if (multi === 4096) {
            this._currentMulti = 4096;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.9, Number.MAX_VALUE);
        } else if (multi === 8192) {
            this._currentMulti = 8192;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 1.0, Number.MAX_VALUE);
        }
        return tl;
    }

    public getMultiSound(multi: number): TimelineLite {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        if (multi === 16 && this._currentMulti === 2) {
            this._currentMulti = 16;
        } else if (multi === 32 && this._currentMulti === 16) {
            this._currentMulti = 32;
        } else if (multi === 64 && this._currentMulti === 32) {
            this._currentMulti = 64;
        } else if (multi === 128 && this._currentMulti === 64) {
            this._currentMulti = 128;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.4, Number.MAX_VALUE);
        } else if (multi === 256 && this._currentMulti === 128) {
            this._currentMulti = 256;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.5, Number.MAX_VALUE);
        } else if (multi === 512 && this._currentMulti === 256) {
            this._currentMulti = 512;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.6, Number.MAX_VALUE);
        } else if (multi === 1024 && this._currentMulti === 512) {
            this._currentMulti = 1024;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.7, Number.MAX_VALUE);
        } else if (multi === 2048 && this._currentMulti === 1024) {
            this._currentMulti = 2048;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.8, Number.MAX_VALUE);
        } else if (multi === 4096 && this._currentMulti === 2048) {
            this._currentMulti = 4096;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 0.9, Number.MAX_VALUE);
        } else if (multi === 8192 && this._currentMulti === 4096) {
            this._currentMulti = 8192;
            DumpsterFire.soundPlayer.playMultiSound(DumpsterFireSound.MULTI_FIRE, 1.0, Number.MAX_VALUE);
        }
        return tl;
    }

    public getRandomNumber(arr: string[]): string {
        if (arr.length === 0) {
            arr = ["extraSpinYes1", "extraSpinYes2", "extraSpinYes3"];
        }
        const randomIndex: number = Math.floor(Math.random() * arr.length);
        const randomNumber: string = arr[randomIndex];

        // Remove the number from the array to prevent it from being selected again
        arr.splice(randomIndex, 1);

        return randomNumber;
    }

    public stopOutroCountUp(): void {
        if (this._countUpSound && this._countUpSound.isPlaying) {
            this._countUpSound.stop();
        }
        let sound: string = DumpsterFireSound.COUNT_UP_END_FS;
        this.playSound(sound);
    }


    public stopCountUp(): void {
        if (this._countUpSound && this._countUpSound.isPlaying) {
            this._countUpSound.stop();
        }
        let winRatioConfig: IWinRatioConfig = DumpsterFire.model.winRatioConfig;
        let sound: string = DumpsterFireSound.COUNT_UP_END_LARGE;

        if (winRatioConfig) {
            if (winRatioConfig.type === DumpsterFireWinTypes.TINY) {
                sound = DumpsterFireSound.COUNT_UP_END_TINY;
            } else if (winRatioConfig.type === DumpsterFireWinTypes.SMALL) {
                sound = DumpsterFireSound.COUNT_UP_END_SMALL;
            } else if (winRatioConfig.type === DumpsterFireWinTypes.MEDIUM) {
                sound = DumpsterFireSound.COUNT_UP_END_MEDIUM;
            }
        }
        if (!DumpsterFire.totalWinView.isPlayedCountUpEnds) {
            this.playSound(sound);
            DumpsterFire.totalWinView.isPlayedCountUpEnds = true;
        }
    }

    public playSound(name: string, repeat?: number): NolimitHowl | undefined {
        return this.player.playTrack(DumpsterFireSound.createConfig(name, 1, repeat));
    }

    public fadeSound(name: string, volume: number, repeat?: number): NolimitHowl | undefined {
        return this.player.playTrack(DumpsterFireSound.createConfig(name, volume, repeat));
    }

    public playMultiSound(name: string, volume: number, repeat?: number): NolimitHowl | undefined {
        return this.player.playTrack(DumpsterFireSound.createConfig(name, volume, repeat));
    }

    public stopSound(name: string) {
        this.player.stopTrack(name);
    }

    public startCountUp(): void {
        this._countUpSound = this.playSound(DumpsterFireSound.COUNT_UP);
        if (this._countUpSound) {
            this._countUpSound.setLoop(true);
        }
    }

    public switchMusic(mode: GameMode | string) {
        let nextMusic = "";

        switch (mode) {
            case "FS_OUTRO_MUSIC":
                nextMusic = DumpsterFireSound.FS_OUTRO_MUSIC;
                break;
            case "CAP_WIN_START":
                nextMusic = DumpsterFireSound.CAP_WIN_START;
                break;
            case "FS_INTRO_MUSIC":
                nextMusic = DumpsterFireSound.FS_INTRO_MUSIC;
                break;
            case GameMode.FREESPIN:
                nextMusic = DumpsterFireSound.FS_INTRO;
                break;
            default:
                nextMusic = DumpsterFireSound.MAIN_GAME_MUSIC;
                break;
        }

        if (nextMusic == this._currentMusic) {
            return;
        }

        if (this._currentMusic) {
            this.player.stopTrack(this._currentMusic);
        }

        this.player.playTrack(DumpsterFireSound.createConfig(nextMusic, 1, undefined));
        this._currentMusic = nextMusic;
    }
}